import { Controller } from "@hotwired/stimulus"

// FD-401: the "Suggest an improvement" dialog. On a SUCCESSFUL submit (the server
// answered with a turbo_stream toast, not a re-rendered form) close the dialog and
// reset the form so the next open starts clean. On a validation error
// (event.detail.success === false) the server re-renders the form with the message,
// so we leave the dialog open. The controller is on the <dialog> element itself.
export default class extends Controller {
  submitEnd(event) {
    if (!event.detail?.success) return
    this.element.querySelector("form")?.reset()
    this.element.close?.()
  }
}
